import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ContactForm from './ContactForm';
import updateOrganisationContactService from '../../services/contacts/updateOrganisationContactService';
import OrganisationContactService from '../../services/contacts/organisationContactService';
import { mapContact } from '../../helpers/contacts/mapContact';

const EditContact = ({
  open,
  dispatchUpdateOrganisationContactPut,
  updateOrganisationContactFetch,
  dispatchOrganisationContactGet,
  organisationContactFetch,
  organisationId,
  contactId,
  returnRoute,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateOrganisationContactPut(
        organisationId,
        contactId,
        mapContact(body),
        () => navigate(returnRoute),
        t
      ),
    [organisationId, contactId, returnRoute, dispatchUpdateOrganisationContactPut, navigate, t]
  );

  useEffect(() => {
    if (open && organisationId) {
      dispatchOrganisationContactGet(organisationId, contactId, () => navigate(returnRoute), t);
    }
  }, [organisationId, contactId, open, t, returnRoute, dispatchOrganisationContactGet, navigate]);

  const defaultData = useMemo(
    () => !organisationContactFetch.pending && organisationContactFetch.value,
    [organisationContactFetch]
  );

  if (!open) return null;

  return (
    <ContactForm
      header={t('editContact')}
      onSubmit={handleSubmit}
      submitProcessing={updateOrganisationContactFetch.pending}
      returnRoute={returnRoute}
      cancelRoute={returnRoute}
      dataLoading={organisationContactFetch.pending}
      data={defaultData}
      editMode
    />
  );
};

EditContact.propTypes = {
  dispatchUpdateOrganisationContactPut: PropTypes.func.isRequired,
  updateOrganisationContactFetch: PropTypes.object.isRequired,
  dispatchOrganisationContactGet: PropTypes.func.isRequired,
  organisationContactFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

EditContact.defaultProps = { open: false };

export default compose(OrganisationContactService, updateOrganisationContactService)(EditContact);
